import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/blogs/${slug}`).then(r => { setBlog(r.data); setLoading(false); }).catch(() => { setLoading(false); navigate('/blogs'); });
  }, [slug, navigate]);

  if (loading || !blog) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header />

      <article className="container mx-auto px-4 py-12 pt-20 max-w-3xl" data-testid="blog-detail">
        <Button variant="ghost" onClick={() => navigate('/blogs')} className="mb-6" data-testid="back-to-blogs-button">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Journal
        </Button>

        {blog.image_url && (
          <div className="rounded-2xl overflow-hidden mb-8 aspect-video">
            <img src={blog.image_url} alt={blog.title} className="w-full h-full object-cover" data-testid="blog-detail-image" />
          </div>
        )}

        <div className="mb-8">
          <p className="text-xs text-muted-foreground uppercase tracking-wider mb-3">{blog.author} | {new Date(blog.created_at).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <h1 className="text-3xl sm:text-4xl font-black font-heading" data-testid="blog-detail-title">{blog.title}</h1>
        </div>

        <div
          className="prose prose-lg max-w-none text-foreground prose-headings:font-heading prose-headings:text-foreground prose-a:text-primary"
          dangerouslySetInnerHTML={{ __html: blog.content }}
          data-testid="blog-detail-content"
        />
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetailPage;
